/* eslint-disable prettier/prettier */
import { makeStyles } from '@material-ui/core';
import { Col, Row } from 'antd';
import { User } from 'mdello-client-ts/dist/src/interfaces/common/user.interface';
import { ChangeEvent, Dispatch, FC, SetStateAction, useState } from 'react';
import CButton from 'src/component/Button';
import { CStandardInput } from 'src/component/Input';
import Modal from 'src/component/Modal/Modal';

const useStyles = makeStyles({
  garbage: {
    cursor: 'pointer',
    left: '8px',
    position: 'absolute',
    top: '0px'
  },
  keyWrapper: {
    '& p': {
      margin: '0px'
    },
    alignItems: 'center',
    display: 'flex'
  },
  modalTitle: {
    fontFamily: 'Poppins',
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: '24px',
    margin: '0px',
  },
  removeButton: {
    alignItems: 'center',
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    marginTop: '12px',
    padding: '0px 6px'
  },
  root: {
    ' & .MuiInputBase-root': {
      border: '1px solid #CAD8FF',
      borderRadius: '12px',
      color: 'black',
      padding: '12.75px 16px'
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: '#9BA0AD'
    },
    '& .MuiInput-inputMultiline': {
      alignItems: 'flex-start',
      height: '110px'
    },
    '& .MuiInput-underline:before': {
      display: 'none'
    },
    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px'
    },

    '& .MuiInputLabel-formControl': {
      fontSize: '12px',
      left: '10px',
      top: '7px'
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(-10px, -10px) scale(0.83)'
    }
  },
  tagItemWrapper: {
    alignItems: 'center',
    display: 'flex',
    gap: '6px',
    justifyContent: 'space-evenly'
  },
  tagItemWrapperAdd: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-evenly'
  },
  tagsItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    justifyContent: 'space-evenly'
  }
});

interface CustomersDetailsTagsModalProps {
  customerDraft: User;
  onSave: () => void,
  setCustomerDraft: Dispatch<SetStateAction<User>>;
  setShowModal: Dispatch<SetStateAction<boolean>>;
  showModal: boolean;
  tags: Record<string, string> | undefined;
}

const CustomersDetailsTagsModal: FC<CustomersDetailsTagsModalProps> = ({
  showModal,
  setShowModal,
  tags,
  setCustomerDraft,
  customerDraft,
  onSave
}) => {
  const classes = useStyles();
  const [tagsDraft, setTagsDraft] = useState<Record<string, string> | undefined>(tags);
  const [newTagKey, setNewTagKey] = useState<string>('');
  const [newTagValue, setNewTagValue] = useState<string>('');

  const onObjectValueChange = (value: string, path: string) => {
    setTagsDraft({
      ...tagsDraft,
      [path]: value
    });
    setCustomerDraft({
      ...customerDraft,
      tags: tagsDraft
    })
  };

  const onObjectKeyAdd = () => {
    setTagsDraft({
      ...tagsDraft,
      [newTagKey]: newTagValue
    });
    setCustomerDraft({
      ...customerDraft,
      tags: tagsDraft
    })
    setNewTagKey('');
    setNewTagValue('');
  };
  const removeKey = (key: string) => {
    if (!tagsDraft) return;
    const tempDraft = { ...tagsDraft };
    delete tempDraft[key];
    setTagsDraft(tempDraft);
    setCustomerDraft({
      ...customerDraft,
      tags: tagsDraft
    })
  };

  const saveTags = () => {
    setCustomerDraft({
      ...customerDraft,
      tags: tagsDraft
    });

    onSave()

    setShowModal(false);
  };

  return (
    <Modal
      contentStyle={{
        maxHeight: '252px'
      }}
      footerActions={
        <CButton onClick={saveTags} size="large" type="primary">
          Save
        </CButton>
      }
      handleClose={() => setShowModal(false)}
      isModalOpen={showModal}
      scrollType="paper"
      styles={{
        maxHeight: '417px',
        overflowY: 'auto'
      }}
      titleContent={
        <div className={classes.modalTitle}>
          Add or Edit tags
        </div>
      }
    >
      <div style={{ width: '100%' }}>
        <Row align="middle">
          <Col
            span={24}
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              justifyContent: 'flex-start'
            }}
          >
            <div className={classes.tagsItem}>
              {tagsDraft &&
                Object.entries(tagsDraft)?.map((tagEntry, index) => {
                  return (
                    <div key={index} className={classes.tagItemWrapper}>
                      <CStandardInput
                        allowClear
                        disabled
                        disableUnderline
                        formclasses={{ root: classes.root }}
                        htmlFor="standard-input-customer-tags-object-key"
                        id="standard-input-customer-tags-object-key"
                        label="tag key"
                        size="large"
                        value={tagEntry[0]}
                        width="true"
                      />
                      <CStandardInput
                        allowClear
                        disableUnderline
                        formclasses={{ root: classes.root }}
                        htmlFor="standard-input-customer-tags-object-value"
                        id="standard-input-customer-tags-object-value"
                        label="tag value"
                        onChange={(e: ChangeEvent<HTMLInputElement>) =>
                          onObjectValueChange(e.target.value, tagEntry[0])}
                        size="large"
                        value={tagEntry[1]}
                        width="true"
                      />

                      <button
                        className={classes.removeButton}
                        onClick={() => removeKey(tagEntry[0])}
                        type="button"
                      >
                        x
                      </button>
                    </div>
                  );
                })}
            </div>
            <div className={classes.tagItemWrapper}>
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-customer-tags-object-key"
                id="standard-input-customer-tags-object-key"
                label="tag key"
                onChange={(e: ChangeEvent<HTMLInputElement>) => setNewTagKey(e.target.value)}
                size="large"
                value={newTagKey}
                width="true"
              />
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-customer-tags-object-value"
                id="standard-input-customer-tags-object-value"
                label="tag value"
                onChange={(e: ChangeEvent<HTMLInputElement>) => setNewTagValue(e.target.value)}
                size="large"
                value={newTagValue}
                width="true"
                      />
              <CButton
                onClick={onObjectKeyAdd}
                size="large"
                type="secondary"
                xstyle={{ marginTop: '12px' }}
              >
                Add
              </CButton>
            </div>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default CustomersDetailsTagsModal;
